import { render } from "./VolumeOff.vue?vue&type=template&id=1f401e80"
const script = {}
script.render = render

export default script